export const VENDOR_TABLE_COLUMNS_STORAGE_KEY = "vendor-table-column-visibility";

export const VENDOR_TOGGLEABLE_COLUMNS = [
    { id: "emails", label: "Email(s)" },
    { id: "account", label: "Account Number" },
    { id: "category", label: "Category" },
    { id: "paymentTerms", label: "Payment Terms" },
    { id: "netTerms", label: "Net Terms" },
    { id: "status", label: "Status" },
];

export const DEFAULT_VENDOR_COLUMN_VISIBILITY = VENDOR_TOGGLEABLE_COLUMNS.reduce(
    (acc, column) => ({ ...acc, [column.id]: true }),
    {}
);

export const loadVendorColumnVisibility = () => {
    try {
        const saved = localStorage.getItem(VENDOR_TABLE_COLUMNS_STORAGE_KEY);
        if (!saved) return DEFAULT_VENDOR_COLUMN_VISIBILITY;

        const parsed = JSON.parse(saved);
        return VENDOR_TOGGLEABLE_COLUMNS.reduce((acc, column) => ({
            ...acc,
            [column.id]: parsed[column.id] !== false,
        }), {});
    } catch {
        return DEFAULT_VENDOR_COLUMN_VISIBILITY;
    }
};

export const saveVendorColumnVisibility = (visibility) => {
    localStorage.setItem(VENDOR_TABLE_COLUMNS_STORAGE_KEY, JSON.stringify(visibility));
};
